(function ($, Global) {
    function CarteModel() {
        // Déclaration class objet
    }

	CarteModel.prototype.getCountry = function (data, callback) {
        if (data.Publication && !Array.isArray(data.Publication))
            data.Publication = [data.Publication];

		$.ajaxPost('/ajax/articles/articlespays', data).done(function (result) {
			Global.ajaxCallback({
				results: result,
				success: callback
			});
		});
	}

	Global.CarteModel = CarteModel;
}(jQuery, window));